export default __webpack_public_path__ + "6fc76af7dff0ef608050423ac8360d01.png";